module.exports = __webpack_public_path__ + "img/user-plus-solid.d2363675.svg";